//  引入vue和axios
import Vue from "vue";
import axios from "axios";

axios.defaults.retry = 4;
axios.defaults.retryDelay = 60 * 1000;

//  继承vue的原型方法
Vue.prototype.axios = axios;

const base = '/api';

const service = axios.create({
  // baseURL: 'http://localhost:4000',
  // baseURL: 'http://120.26.50.212',
  baseURL: 'http://admin.njxianhe.com',
  timeout: 60 * 1000
})

service.interceptors.request.use(config => {
  const token = localStorage.getItem('XXXUserToken');
  if (token) {
    /* Bearer是JWT的认证头部信息 */
    config.headers.common['Authorization'] = 'Bearer ' + token;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

service.interceptors.response.use(
  response => {
    let data = response.data;
    if (!data.data) {
      //    登陆成功的回调地址
      return data;
    } else {
      return data;
    }
  },
  error => {
    //  返回接口返回的错误信息
    return Promise.reject(error.response)
  }
);

const baseURL = '/api/koa';

export default {
  /* 登陆 - post */
  login: (params) => {
    return service.post(`${baseURL}/login`, params)
  },
  /* 注册 - post */
  register: (params) => {
    return service.post(`${baseURL}/register`, params)
  },
  // 导航列表 不分页
  menuListNoPagination: (params) => {
    let data = { params: params };
    return service.get(`${base}/menu/query`, data)
  },
  // 导航id 获取内容
  menuIdContent: (params) => {
    let data = { params: params };
    return service.get(`${base}/menu/getContentById`, data)
  },
  // 文章id 获取内容
  getRichTextContent: (params) => {
    let data = { params: params };
    return service.get(`${base}/richText/queryById`, data)
  },
  // 根据菜单分页获取富文本列表
  getRichTextContentPage: (params) => {
    let data = { params: params };
    return service.get(`${base}/richText/queryForPage`, data)
  },



/* *
 * API demo
 *
 * getAPI: (params) => {
 *    getConfig.params = params.params
 *    return axios.get('xxxx.do', getConfig)
 * }
 *
 * postAPI: (params) => {
 *     return axios.post('xxxx.do', params, postConfig)
 * }
  */
}
